import { Component, computed, inject,
    ChangeDetectionStrategy
} from '@angular/core';
import { injectTippyRef } from '@ngneat/helipopper';
import { MainAppService } from 'src/modules/app-template/services/main-app.service';
import { Arrays } from 'src/modules/utils/shared/arrays';
import { Dates } from 'src/modules/utils/shared/dates';
import { CalendarEvent } from '../../netgen/CalendarEvent';
import { CalendarEventKind } from '../../netgen/CalendarEventKind';
import { ProjectPlanningService } from '../../services/project-planning.service';

@Component({
  selector: 'app-calendar-event-tool-tip',
  standalone: false,
  templateUrl: './calendar-event-tool-tip.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './calendar-event-tool-tip.component.scss'
})
export class CalendarEventToolTipComponent {

    _CalendarEventKind = CalendarEventKind;

    service = inject(ProjectPlanningService);
    app = inject(MainAppService);

    tippy = injectTippyRef();
    event = computed(() => this.tippy.data.event as CalendarEvent);
    type = computed(() => this.tippy.data.type as string);
    noteText = computed(() => {
        const note = (this.event().note ?? "").replace(/\r\n?/g, "\n");
        const lines = note.split("\n");
        let result = lines.slice(0, 10).join("\n");
        const truncated = lines.length > 10 || result.length > 500;
        result = result.substring(0, truncated ? 497 : 500);
        return result + (truncated ? "..." : "");
    });

    getUserNameText(): string {
        let result = this.event().getAllEditorsText(this.service, false);
        return result;
    }

    getContactPersonText(): string {
       return this.service.getUserShortName(this.event().contactPersonId);
    }

    getCreatedByText(): string {
       return this.service.getUserShortNameByUserName(this.event().createdBy, true);
    }

    getModifiedByText(): string {
       return this.service.getUserShortNameByUserName(this.event().modifiedBy, true);
    }

    getProjectNumber(): string {
        return this.service.projects.find(p => p.id == this.event().projectId)?.projectNumber ?? "<???>";
    }

    getProjectTitle(): string {
        return this.service.projects.find(p => p.id == this.event().projectId)?.title ?? "<???>";
    }
    
    getResourcesText(): string {
        return this.event().getAllResourcesText(this.service);
    }

    getDate(): string {
        let ed = this.event().getDisplayEndDate();
        return this.event().formatDate(this.event().startDate) + (Dates.eq(ed, this.event().startDate) ? "" : " - " + this.event().formatDate(this.event().getDisplayEndDate()));
    }

    getParticipantsText(): string {
        let result = Arrays.itemsToString(Arrays.sort((this.event().participants ?? []).map(p => p.userId != null ? this.service.getUserShortName(p.userId) : p.mail)), ", ");
        return result != "" ? this.app.t("entity.CalendarEvent.fields.participants") + ": " + result : ""; 
    }
}
